'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CANCELLATION_EARLY = exports.CANCELLATION_EARLY = 'early';
var CANCELLATION_LATE = exports.CANCELLATION_LATE = 'late';
var CANCELLATION_FLYWHEEL = exports.CANCELLATION_FLYWHEEL = 'FLYWHEEL';